import { EnumBadge } from '@mxa-argos/components/custom/enum-badge';
import { SearchItemLayout } from '@mxa-argos/modules/search/components/search-item-layout';
import type { SearchResult } from '@mxa-argos/modules/search/hooks/use-resource-search';
import { PhoneForwarded } from 'lucide-react';

interface Props {
  result: SearchResult;
}

export function PortabilitySearchItem({ result }: Props) {
  return (
    <SearchItemLayout
      icon={PhoneForwarded}
      primary={result.primary}
      secondary={
        result.secondary && (
          <EnumBadge enumName="PortabilityStatus" value={result.secondary} size="sm" />
        )
      }
      tertiary={result.tertiary}
      quaternary={result.quaternary}
    />
  );
}
